import LinkedText from "../linkedText/linkedText.component";

export interface EGridItem {
  title: string;
  // Supports `[label](/route)` links and `**bold**` (see LinkedText).
  text: string;
}

interface EGridProps {
  items: EGridItem[];
  // Fine print under the grid, e.g. "Fydo does not promise...".
  note?: string;
}

// Benefits as ruled entries: a heavy ink rule above each title, two columns
// from `lg` (the preview's `.e-grid` of `.benefit`s plus its `.e-note`).
const EGrid = ({ items, note }: EGridProps) => (
  <>
    <div className="grid lg:grid-cols-2 lg:gap-x-16">
      {items.map((item) => (
        <div key={item.title} className="border-t-2 border-ink pt-6 pb-9">
          <h3 className="text-[1.2rem] leading-snug font-bold tracking-[-0.01em]">
            {item.title}
          </h3>
          <p className="mt-2 text-[17px] leading-relaxed text-ink-muted">
            <LinkedText text={item.text} />
          </p>
        </div>
      ))}
    </div>
    {note && <p className="mt-2 text-sm text-ink-muted">{note}</p>}
  </>
);

export default EGrid;
